/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SignupWizardLayoutComponent } from './signup-wizard-layout/signup-wizard-layout.component';
import { getSignupRights } from '@well/rights';
import { ChooseAccountTypeComponent } from './steps/choose-account-type/choose-account-type.component';
import { CompanyInfoComponent } from './steps/company-info/company-info.component';
import {
  signupAccountTypeStepSegment,
  signupCompanyInfoStepSegment,
  signupContactStepSegment,
  signupPaymentInfoStepSegment,
  signupPaymentInfoStepSubscriptionTypeSegment,
  signupPaymentMethodPendingSegment,
  signupSubscriptionStepSegment
} from '@well/navigation';
import { ChooseSubscriptionComponent } from './steps/choose-subscription/choose-subscription.component';
import { FirstContactComponent } from './steps/first-contact/first-contact.component';
import { PaymentMethodStepComponent } from './steps/payment-method-step/payment-method-step.component';
import { PaymentMethodPendingStepComponent } from './steps/payment-method-pending-step/payment-method-pending-step.component';
import { signupSubscriptionGuard } from '../guards/signup-subscription.guard';

const routes: Routes = [
  {
    path: '',
    component: SignupWizardLayoutComponent,
    data: {
      authorities: [getSignupRights()]
    },
    children: [
      {
        path:'',
        pathMatch: 'full',
        redirectTo: signupAccountTypeStepSegment
      },
      {
        path: signupAccountTypeStepSegment,
        component: ChooseAccountTypeComponent
      },
      {
        path: `${signupCompanyInfoStepSegment}/:type`,
        component: CompanyInfoComponent
      },
      {
        path: `${signupSubscriptionStepSegment}/:legalEntityUuid`,
        component: ChooseSubscriptionComponent,
        canActivate: [signupSubscriptionGuard]
      },
      {
        path: `${signupPaymentInfoStepSegment}/:legalEntityUuid/${signupPaymentInfoStepSubscriptionTypeSegment}/:subscriptionTypeUuid`,
        component: PaymentMethodStepComponent
      },
      {
        path: `${signupPaymentMethodPendingSegment}/:legalEntityUuid`,
        component: PaymentMethodPendingStepComponent
      },
      {
        path: `${signupContactStepSegment}/:legalEntityUuid`,
        component: FirstContactComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SignupWizardFeatureRoutingModule { }

